import React, { useEffect } from "react";
import { loadScriptsSequentially } from "../utils";
import "./Home.css";
import "../components/carousel/CardCarousel.css";

function ThanksPage() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "Lead");
    }

    const script = document.createElement("script");
    script.src =
      "https://app.huberway.org/assets/plugins/jquery/jquery-3.2.1.min.js?v=" +
      Date.now();
    script.onload = () => {
      loadScriptsSequentially([
        "js/pre-loader.js",
        "assets/bootstrap/js/popper.min.js",
        "assets/bootstrap/js/bootstrap.min.js",
        "js/parallaxie.js",
        "js/TweenMax.min.js",
        "js/jquery.wavify.js",
        "assets/wow/wow.min.js",
        "assets/counterup/jquery.counterup.min.js",
        "assets/counterup/jquery.waypoints.min.js",
        "js/main.js",
      ]);
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div
      className="divmain"
      style={{ textAlign: "center", padding: "50px", height: "70vh" }}
    >
      <div className="section_title text-center mb-0">
        <i
          className="fas fa-check-circle"
          style={{ fontSize: "60px", color: "green" }}
        ></i>
        <h2 className="h_title wow fadeInUp" style={{ marginTop: "20px" }}>
          GRAZIE PER AVER CANDIDATO LA VOSTRA BOUTIQUE!
        </h2>
        <img
          className="mt-5"
          style={{ width: "500px" }}
          src="https://cdn.psicopaticiservice.com/cropped-psi-v1-black.png"
          alt="logo"
        />
        <p className="mt-5" style={{ fontSize: "18px", marginTop: "10px" }}>
          In 2-3 giorni lavorativi sarete contattati per ulteriori informazioni.
        </p>
      </div>
    </div>
  );
}

export default ThanksPage;
